import React from 'react';
export function TopBar() {
  return <div className="bg-deco-forest text-deco-cream/80 py-2 px-4 text-center text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.2em]" data-id="element-234" data-mp="3sdww54cn05jm">
      <p data-id="element-235" data-mp="1y3k96y4t3fpf">Producto 100% digital · Descarga inmediata</p>
    </div>;
}